import Dexie, { liveQuery, Table } from 'dexie';
import {
  DB_DRIVE_NAME,
  DB_DRIVE_SCHEMA_V2,
  DB_DRIVE_SCHEMA_V3
} from '../../service-worker/drive/service-worker.constants';
import { PhotoRequestRecord, RequestRecord, RETRY_PENDING } from '../../service-worker/drive/request.interface';
import { Protocol } from '../base/entities/protocol';
import { CounterPartyNoteRecord } from '../base/entities/counter-party-note-record.interface';

export class DriveDatabase extends Dexie {
  readonly requests: Table<RequestRecord, string>;
  readonly photoRequests: Table<PhotoRequestRecord, string>;
  readonly protocol: Table<Protocol, string>;
  readonly counterPartyNotes: Table<CounterPartyNoteRecord, string>;

  constructor() {
    super(DB_DRIVE_NAME);
    this.version(2).stores(DB_DRIVE_SCHEMA_V2);
    this.version(3).stores(DB_DRIVE_SCHEMA_V3);
  }

  saveRequest(request: RequestRecord) {
    return this.requests.put({ ...request }, request.entity.id);
  }

  getAllRequestsReactive() {
    return liveQuery(() => this.requests.toArray());
  }

  retryRequestById(id: string) {
    return this.requests.update(id, { retry: RETRY_PENDING() });
  }

  hasRequests() {
    return this.requests.count().then((number) => number > 0);
  }

  savePhotoRequest(photoRequest: PhotoRequestRecord) {
    return this.photoRequests.put({ ...photoRequest }, photoRequest.photo.id);
  }

  getAllPhotoRequestsReactive() {
    return liveQuery(() => this.photoRequests.toArray());
  }

  retryPhotoRequestById(id: string) {
    return this.photoRequests.update(id, { retry: RETRY_PENDING() });
  }

  hasPhotoRequests() {
    return this.photoRequests.count().then((number) => number > 0);
  }
}

export const driveDatabase = new DriveDatabase();
